import React, { useMemo, useRef, useState } from 'react';
import customerSelectors from 'features/customer/services/selectors';
import { IAccountPackage } from 'features/customer/services/types/api';
import { CustomerInfoPopover } from 'features/user/widgets/WaitingList/WalkIn/components/CustomerName';
import { IStaffItemData } from 'services/shop/types/staff';
import { useAppDispatch } from 'store/hooks';
import { customerEditorRef } from '../../widgets/CustomerEditor';
import appointmentActions from 'features/appointment/services/actions';
import customerActions from 'features/customer/services/actions';

const useControlCustomerInfoPopover = (
  customerId: string
) => {
  const dispatch = useAppDispatch();
  const dataCustomer = customerSelectors.popoverCustomerDetail();
  const customerDetailLoading =
    customerSelectors.popoverCustomerDetailLoading();
  const [open, setOpen] = useState(false);
  const [pinData, setPinData] = useState<IStaffItemData>();
  const isEditAfterCheckPinCode = useRef(false);

  const customerInfo: CustomerInfoPopover = useMemo(() => {
    return {
      customerId: dataCustomer?.id || '',
      customerName: dataCustomer?.name || '',
      customerPhone: dataCustomer?.phone || '',
      customerNote: dataCustomer?.note || '',
      customerHobbies: dataCustomer?.hobbies || '',
      customerColor: dataCustomer?.color || '',
      customerHealth: dataCustomer?.health || '',
      lastTimeVisited: dataCustomer?.lastVisitedDate || '',
      numberVisited: dataCustomer?.numberVisit || 0,
      accountPackage: dataCustomer?.accountPackage || IAccountPackage.NEW,
    };
  }, [dataCustomer]);

  const onEdit = () => {
    customerEditorRef.current?.openWithId(customerInfo.customerId, {
      addon: customerInfo,
      onSuccess: (data) => {
        if (data) {
          dispatch(appointmentActions.syncCustomerInfo(data));
          if (isEditAfterCheckPinCode) {
            dispatch(customerActions.viewCustomerDetailById.success(data));
          }
        }
      },
    });
    setOpen(false);
    isEditAfterCheckPinCode.current = false;
  };

  const handleClose = () => {
    setOpen(false);
    isEditAfterCheckPinCode.current = false;
  };

  const handleOpenAfterCheckPinCode = (data: IStaffItemData) => {
    setPinData(data);
    setOpen(true);
    dispatch(customerActions.viewCustomerDetailById.fetch(customerId));
  };

  const fetchCustomerDetail = () => {
    dispatch(customerActions.viewCustomerDetailById.fetch(customerId));
  };

  const handleEditAfterCheckPinCode = (data: IStaffItemData) => {
    isEditAfterCheckPinCode.current = true;
    setPinData(data);
    setOpen(true);
    onEdit();
  };

  return {
    customerInfo,
    customerDetailLoading,
    fetchCustomerDetail,
    open,
    pinData,
    onEdit,
    handleClose,
    handleOpenAfterCheckPinCode,
    handleEditAfterCheckPinCode,
  };
};

export default useControlCustomerInfoPopover;
